// extracted by mini-css-extract-plugin
export default {"loading":"Loading-module--loading--sOaog","loadingSpinner":"Loading-module--loadingSpinner--p13G2"};